import apiConnector from '@/epersonam/apiConnector';

const printDiuresis24h = (gpdsId, fromSelector, toSelector, printButton, buttonCloseId) => {
  const selectFrom = document.querySelector(fromSelector);
  const selectTo = document.querySelector(toSelector);
  const button = document.querySelector(printButton);
  const buttonClose = document.querySelector(buttonCloseId);

  if (selectFrom.value && selectTo.value) {
    button.onclick = () => {
      const baseUrl = `${window.config.ePersonamService.ePersonamHost}/${window.locale}`;
      const printDiuresis24hUrl = `${baseUrl}/reports/generate_report.json?guest_period_data_set_id=${gpdsId}&from=${selectFrom.value}&to=${selectTo.value}&worker=ShowDiuresisPdfWorker`;
      apiConnector()
        .get(printDiuresis24hUrl)
        .then((response) => {
          eventBus.$emit('generateReport', response.data);
        });
      buttonClose.click();
    };
  } else {
    button.disabled = true;
  }
};

const init = (gpdsId, fromSelector, toSelector, printButton, buttonCloseId) => {
  try {
    printDiuresis24h(gpdsId, fromSelector, toSelector, printButton, buttonCloseId);
  } catch (e) {
    console.log(e);
  }
};

window.PrintDiuresis24hReport = {
  init: init,
};
